import { render, staticRenderFns } from "./OrderListGoodsAll.vue?vue&type=template&id=685ac56f&scoped=true"
import script from "./OrderListGoodsAll.vue?vue&type=script&lang=js"
export * from "./OrderListGoodsAll.vue?vue&type=script&lang=js"
import style0 from "./OrderListGoodsAll.vue?vue&type=style&index=0&id=685ac56f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685ac56f",
  null
  
)

export default component.exports